import { Box, Button, Divider, Popover, Stack, Typography, useTheme } from "@mui/material";
import { DateTime } from "luxon";
import { AddIssueOrTaskButton, TextViewer } from "../../../../components";
import { KeyboardArrowDown, ReviewsOutlined } from "@mui/icons-material";
import { ISurveyResponseAnswer } from "../../../../models";
import { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "../../../../http";
import { CreatedItemsPopoverContent } from ".";

interface IProps {
  responseAnswer: ISurveyResponseAnswer;
}

const TextResponse = (props: IProps) => {
  const [menuAnchor, setMenuAnchor] = useState<HTMLElement | null>(null);
  const theme = useTheme();
  const queryClient = useQueryClient();

  return (
    <Stack spacing={0.5}>
      <Box>
        <Stack
          direction="row"
          spacing={0.25}
          divider={
            <Divider
              orientation="vertical"
              flexItem
              sx={{ color: theme.palette.grey[300], height: "15px", alignSelf: "center" }}
            />
          }
          sx={{
            alignItems: "center",
          }}
        >
          <Typography variant="caption">{props.responseAnswer.teamName}</Typography>
          <Typography variant="caption">
            {DateTime.fromISO(props.responseAnswer.submittedOnDateTimeUtc, { zone: "utc" })
              .toLocal()
              .toLocaleString(DateTime.DATE_MED)}
          </Typography>
        </Stack>
      </Box>

      <TextViewer value={props.responseAnswer.textAnswer} />

      <Stack direction="row" spacing={1}>
        <AddIssueOrTaskButton
          startIcon={<ReviewsOutlined />}
          text="Process Response"
          createdFromSurveyResponseAnswer={props.responseAnswer}
          onItemAdded={() => queryClient.invalidateQueries(queryKeys.surveys.getSurveyCoherenceReportAll())}
        />

        {props.responseAnswer.createdItemCount > 0 && (
          <>
            <Button
              variant="tertiary"
              onClick={(e) => setMenuAnchor(e.currentTarget)}
              endIcon={<KeyboardArrowDown />}
            >{`${props.responseAnswer.createdItemCount} Conversations Opened`}</Button>
            <Popover
              anchorEl={menuAnchor}
              open={Boolean(menuAnchor)}
              onClose={() => setMenuAnchor(null)}
              anchorOrigin={{ vertical: "top", horizontal: "left" }}
              transformOrigin={{ vertical: "top", horizontal: "right" }}
            >
              <CreatedItemsPopoverContent
                responseAnswerGuid={props.responseAnswer.answerGuid}
                loadingEnabled={Boolean(menuAnchor)}
                onItemClick={() => setMenuAnchor(null)}
              />
            </Popover>
          </>
        )}
      </Stack>
    </Stack>
  );
};

export { TextResponse };
